import { createFileRoute } from "@tanstack/react-router";
import { GoogleReviewPage, buildGoogleReviewHead } from "@/components/shop/GoogleReviewPage";
import { googleReviewDict } from "@/lib/shop/products/google-review";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/shop_/google-review")({
  head: () => ({
    ...buildGoogleReviewHead(googleReviewDict),
    links: alternateLinkList("/shop/google-review", "en"),
  }),
  component: () => <GoogleReviewPage dict={googleReviewDict} />,
});